<template>

  <div class="myCenter" :key="isArabic">

        <div class="mt-10 w-4/5  lg:w-1/2 swiper-container" >

            <div v-swiper:mySwiper="swiperOptions" >
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide" >
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-dance.jpg" /> 
                        </div>

                        <div class="lg:ms-20 -mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink z-30 w-5/6 opacity-100 shadow-xl rounded-lg lg:me-32">{{$t('ads.imgAd1')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-class.jpg"/> 
                        </div>

                        <div class="lg:ms-20 -mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink z-30 w-5/6 opacity-100 shadow-xl rounded-lg lg:me-32">{{$t('ads.imgAd2')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-ma.jpg"/> 
                        </div>

                        <div class="lg:ms-20 -mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink w-5/6 opacity-100 shadow-xl rounded-lg lg:me-32">{{$t('ads.imgAd3')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div >

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-gym.jpg"  /> 
                        </div>

                        <div class="lg:ms-20 -mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink text- z-30 w-5/6 opacity-100 shadow-xl rounded-lg lg:me-32">{{$t('ads.imgAd4')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-workout.jpg"/> 
                        </div>

                        <div class="lg:ms-20 -mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink text- z-30 w-5/6 opacity-100 shadow-xl rounded-lg lg:me-32">{{$t('ads.imgAd5')}}</label>
                        </div>  

                        <div class="bg-white mt-12"></div>

                    </div>
                </div>
                <div class="swiper-pagination mt-64"></div>
         
               <!-- <div class="swiper-pagination swiper-pagination-bullets mt-10"></div> -->

            </div>
        </div>
  </div>
</template>

<script>

// import { directive } from 'vue-awesome-swiper'

import 'swiper/swiper-bundle.min.css'
//   import LazyHydrate from 'vue-lazy-hydration'
  import {Swiper as SwiperClass, EffectCube, Pagination, Navigation} from 'swiper/swiper.esm.js'
  import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
  SwiperClass.use([EffectCube, Pagination, Navigation])

  const {directive} = getAwesomeSwiper(SwiperClass)

export default {

    mounted(){

        // this.swiper();
    },

    directives: {
       
       swiper: directive
    },

    methods:{

        swiper() {
            
            // return this.$refs.mySwiper.$swiper
        },
    },

    data:function(){

        return{

            isArabic: this.$i18n.locale == 'ar',

            // swiperOptions: {
            //     // loop: true,

            //     // fadeEffect: { crossFade: true },
			// 	effect: "fade", 
            //     //  effect: 'cube',

            //     //  effect: 'coverflow',
            //     //     coverflowEffect: {
            //     //         rotate: 50,
            //     //     },
            //     pagination: {
            //         el: '.swiper-pagination'
            //     },
            //     // Some Swiper option/callback...

            // banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],

            // }    
            
            swiperOptions: {
            
            loop: true,
            // effect: 'fade',
            effect: 'coverflow',

            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true
            }
        }
        }
    },

    watch: {
        
        '$i18n.locale'(newValue) {

                this.isArabic =  this.$i18n.locale == 'ar';          
            }
        },

}
</script>


